var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('button',{staticClass:"wechat",attrs:{"type":"button"},on:{"click":_vm.signIn}},[_vm._v(_vm._s(_vm.t('button-wechat-sign-in')))])])}
var staticRenderFns = []

export { render, staticRenderFns }